import { useAuth } from "@/providers";
import { PageLayout } from "@/shared/components";

import { MetricsContent } from "./components/MetricsContent/MetricsContent";

/**
 * Top-level metrics page mounted at `/metrics`. Resolves the current org from
 * `useAuth` and renders `MetricsContent` (the org-wide view — no device/session
 * filter) inside the standard `PageLayout` header shell used by the other
 * top-level pages. `MetricsContent` shows a Dashboard/Metric Definitions tab bar
 * to admins and just the dashboard to everyone else.
 */
export function MetricsDashboardPage() {
  const { currentOrganization } = useAuth();
  return (
    <PageLayout title="Roboto - Metrics" headerContentLeft="Metrics">
      <MetricsContent orgId={currentOrganization?.org_id} />
    </PageLayout>
  );
}
